/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import { Loader } from 'src/components';
import Form from '../../components/Consent';
import { ConsentFormViewRendererProps } from '../../types';

function Desktop(props: ConsentFormViewRendererProps) {
  const { loading } = props;
  return (
    <>
      <Form {...props} />
      {loading && (
        <div className="fixed top-[50vh] left-[50vw]">
          <Loader />
        </div>
      )}
    </>
  );
}

export default Desktop;
